<template>
    <div id="Home">
  
      <div class="pt-5 carousel-container">
        <HomeFilters />
        <HomeCardContent :title="'Events'" type="corporateEvent" cardType="corporateEvent" class="car" :mute="true" v-if="this.$route.params.content_type === 'events'">
        </HomeCardContent>
        <HomeCardContent title="Videos" class="car" type="standaloneArticles" additionalTag="Videos" :mute="true" v-if="this.$route.params.content_type === 'videos'">
        </HomeCardContent>
        <HomeCardContent title="Articles" class="car" cardType="article" type="standaloneArticles" additionalTag="Articles" :mute="true" v-if="this.$route.params.content_type === 'articles'">
        </HomeCardContent>
  
      </div>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import axios from "axios";
  import config from "../config/constants";
  import Loader from "../components/Loader.vue";
  import HomeCardCarousel from "@/components/Home/New/HomeCardCarousel.vue"
  import HomeCardContent from "@/components/Home/New/HomeCardContent.vue"

  import HomeFilters from "@/components/Home/New/HomeFilters.vue"
  import EventBus from "@/helpers/eventbus";
  
  
  export default {
    name: "home",
    components: {
      Loader,
      HomeCardContent,
      HomeFilters,
    },
    data() {
      return {
        courses: {},
        tag: 'Show all',
        content: false,
        pageType: 'events',
      };
    },
    mounted() {
      let self = this;
      EventBus.$on("setTag", function (tag) {
        self.tag = tag
      });
    },
    methods: {
      navigate(route) {
        this.$router.push(route);
        this.scrollToRef(null, true);
  
      }
    },
    computed: {
      supportContacts() {
          return this.$store.state.user.support_contacts;
        }
    }
  };
  </script>
  <style lang="less">
  #Home {
    overflow-x: hidden;
    background-color: #FAFAFA !important;
  
    .welcome {
      font-size: 1.8rem;
      font-weight: 700;
      letter-spacing: 2.2px;
    }
  
    .content-container {
      padding-right: 16px;
      padding-left: 16px;
    }
  
    .home-banner-container {
      .home-banner {
        padding: 60px 16px 30px;
      }
  
      .home-banner-text {
        font-size: 1.6rem;
        z-index: 2;
  
        .home-banner-title {
          font-size: 6.4rem;
          font-weight: bold;
          padding-bottom: 25px;
        }
  
        p {
          font-size: 1.8rem;
        }
      }
  
      div {
        z-index: 2;
      }
    }
  
    .home-section-container {
      .home-section {
        padding-top: 30px;
      }
  
      .img-fluid {
        width: 100%;
        height: 246px;
        object-fit: cover;
        object-position: center;
      }
  
      .home-section-text {
        text-wrap-style: balance;
        font-size: 1.6rem;
        z-index: 2;
  
        .home-section-title {
          font-size: 6.4rem;
          font-weight: bold;
          padding-bottom: 25px;
        }
  
        p {
          font-size: 1.8rem;
        }
      }
  
      div {
        z-index: 2;
      }
    }
  
    .section-title {
      font-size: 2.8rem;
    }
  
    .healthscore-banner {
      border-radius: 6px;
  
      h3 {
        font-size: 2.4rem;
      }
    }
    .home-card-cta-text{
      font-size: 1.6rem;
      font-weight: 500;
    }
    @media only screen and (max-width: 768px) {
      .home-card-container {
        grid-template-columns: 1fr !important;
      }
    }
  
    @media only screen and (max-width: 768px) {
      .home-card-container {
        grid-template-columns: 1fr !important;
      }
    }
  
    .home-card-container.half {
      grid-template-columns: 1fr 1fr;
    }
  
    .home-card-container {
      padding-bottom: 30px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 30px;
  
      .home-card {
        background-color: white;
        border-radius: 8px;
        margin-top: 20px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        z-index: 2;
        flex-grow: 1;
  
        .home-card-container {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          padding: 15px;
        }
  
        h4 {
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 15px;
          z-index: 10;
        }
  
        p {
          font-size: 1.4rem;
          z-index: 10;
          margin-bottom: 20px;
        }
  
        .home-card-image {
  
          .img-fluid {
            width: 100%;
            height: 246px;
            object-fit: cover;
            object-position: center;
          }
        }
  
        .home-card-button {
          margin-left: -10px;
          padding: 10px;
          font-size: 1.4rem;
        }
  
      }
    }
  
    .home-section-container {
      .home-section {
        padding-top: 30px;
      }
  
      .img-fluid {
        width: 100%;
        height: 246px;
        object-fit: cover;
        object-position: center;
      }
  
      .home-section-text {
        font-size: 1.6rem;
        z-index: 2;
  
        .home-section-title {
          font-size: 6.4rem;
          font-weight: bold;
          padding-bottom: 25px;
        }
  
        p {
          font-size: 1.8rem;
        }
      }
  
      div {
        z-index: 2;
      }
    }
  
    .section-title {
      font-size: 2.8rem;
    }
  
    .healthscore-banner {
      border-radius: 6px;
  
      h3 {
        font-size: 2.4rem;
      }
    }
  
    @media only screen and (max-width: 768px) {
      .home-card-container {
        grid-template-columns: 1fr !important;
      }
    }
  
    @media only screen and (max-width: 768px) {
      .home-card-container {
        grid-template-columns: 1fr !important;
      }
    }
  
    .home-card-container.half {
      grid-template-columns: 1fr 1fr;
    }
  
    .home-card-container {
      padding-bottom: 30px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 30px;
  
      .home-card {
        background-color: white;
        border-radius: 8px;
        margin-top: 20px;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        z-index: 2;
        flex-grow: 1;
  
        .home-card-container {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          padding: 15px;
        }
  
        h4 {
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 15px;
          z-index: 10;
        }
  
        p {
          font-size: 1.4rem;
          z-index: 10;
          margin-bottom: 20px;
        }
  
        .home-card-image {
  
          .img-fluid {
            width: 100%;
            height: 246px;
            object-fit: cover;
            object-position: center;
          }
        }
  
        .home-card-button {
          margin-left: -10px;
          padding: 10px;
          font-size: 1.4rem;
        }
  
      }
    }
  }
  </style>
  